import Vue from "vue";

/**
 * Class App Service
 */
export default class AppService extends Vue {

    private customActions = {
        getMessageByLead: { method: 'GET', url: 'integration/app/get-message/{leadId}' },
        getSentimentByLead: { method: 'GET', url: 'integration/app/get-sentiment/{leadId}' },
        getCSATByLead: { method: 'GET', url: 'lead/evaluation/{leadId}' },
        getOpportunityDetails: { method: 'GET', url: 'lead/id-lead/details/{leadId}' },
        getMessageDetails: { method: 'POST', url: 'lead/message/details/{id_platform}' },
        transhipmentLead: { method: "POST", url: "opportunity/tranship/{leadId}" },
        dispatcherTransshipment: { method: "POST", url: "integration-queue/lead-despatcher" },
    };
    
    private resource: any = this.$resource(
        "/integration/app/",
        {},
        this.customActions
    );

    // GET message app by id lead
    public async getMessageByLead(leadId: number) {
        return await this.resource.getMessageByLead({ leadId }).then(
            (response: any) => {
                return response.json();
            },
            (response: any) => {
                return response.json();
            }
        );
    }

    // GET message app by id lead
    public async getCSATByLead(leadId: number) {
        return await this.resource.getCSATByLead({ leadId }).then(
            (response: any) => {
                return response.json();
            },
            (response: any) => {
                return response.json();
            }
        );
    }

    public async getOpportunityDetails(leadId: number) {
        return await this.resource.getOpportunityDetails({ leadId }).then(
            (response: any) => {
                return response.json();
            },
            (response: any) => {
                return response.json();
            }
        );
    }

    public async getSentimentByLead(leadId: number) {
        return await this.resource.getSentimentByLead({ leadId }).then(
            (response: any) => {
                return response.json();
            },
            (response: any) => {
                return response.json();
            }
        );
    }

    public async getMessageDetails(firstDate: string, lastDate: string, channel?: string, action?: string, status?: string, csat?: number, plugin?: string) {
        const id_platform = this.$auth.user().id_platform;

        const params = {
            firstDate: firstDate,
            lastDate: lastDate,
            channel: channel,
            action: action,
            status: status,
            csat: csat,
            plugin: plugin
        }

        return await this.resource.getMessageDetails({ id_platform }, params).then(
            (response: any) => {
                return response.json();
            },
            (response: any) => {
                return response.json();
            }
        );
    }

    public transhipmentLead(leadId: any) {
        const payload = {
            tranship_reason: "Transbordo Manual",
            tranship_details: "Transbordo realizado manualmente",
            toAction: null
        };
        return this.resource.transhipmentLead({ leadId }, payload).then((response: any) => {
            return response.json();
        }, (response: any) => {
            return response.json();
        });
    }

    public dispatcherTransshipment(params: any) {
        return this.resource.dispatcherTransshipment(params).then((response: any) => {
            return response.json();
        }, (response: any) => {
            return response.json();
        });
    }

}